<script>
import gsap from 'gsap';
import Cookies from "js-cookie";
export default {
  name: "rightBox",
  data() {
    return {
      show: false,
      username:''
    }
  },
  methods: {
    handleScroll() {
      const scroll = document.body.scrollTop || window.scrollY || document.documentElement.scrollTop;
      this.show = scroll > 600;
    },
    getUsername() {
      this.username = Cookies.get('username');
    },
    clearUsername(){
      Cookies.remove('username');
      Cookies.remove('sessionId');
      this.username = '';
    }
  },
  created() {
    // alert('挂在')
    this.getUsername();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

}
</script>

<template>
  <div v-show="show" ref="rightBox" class="rightBannerBox" style="position: fixed;right:20px;top:200px;width:100px;background-color: #ffffff;z-index: 100;">
    <div style="text-align: center;"><img src="@/images/CPXQ28.jpg" style="width: 90px;height: 90%;margin-top: 5px;margin-bottom: 5px;"/></div><!--dm_emt-->
    <ul class="zc_filxed"  >
      <li><a    style="overflow: hidden" v-if="username">{{username}},欢迎</a></li>
      <li><a  @click="clearUsername" v-if="username" >注销</a></li>
      <li><router-link to="/site/login" target="_blank" v-if="!username" >观众登录</router-link></li>
<!--      <li><a href="https://www.nxhzy.cn/swz/registration.html" target="_blank">观众登记</a></li>-->
      <li><router-link to="/site/audienceRegister" target="_blank">观众登记</router-link></li>
      <li><router-link to="/site/register" target="_blank">展商报名</router-link></li>
      <li><a href="https://admin.nxhzy.cn/index" target="_blank">展商后台</a></li>
    </ul>
  </div>
</template>

<style scoped>
.zc_filxed {
  width: 100%;
  list-style: none;
}
.zc_filxed li{
  text-align: center;
  border-top: 2px solid #dee7f8;
}
.zc_filxed li:hover{
  text-align: center;
  border-top: 2px solid #dee7f8;
  color:#fff ;
  background-color: #150e52;
}
.zc_filxed li a{
  text-decoration: none;
  display:block;
  color: #150e52;
  line-height: 40px;
}
.zc_filxed li a:hover{
  text-decoration: none;
  color: #fff;
  line-height: 40px;
}
</style>
